// extracted by mini-css-extract-plugin
export default {"iframe":"iframe__7JPEr","wrapper":"wrapper__4BqEd","main":"main__6IgOD","block":"block__v7J++","blockNum":"blockNum__NuUkR","blockBtn":"blockBtn__LRCmk","navBtn":"navBtn__7YUPY"};